(function($) {
    "use strict";

    $(function() {
        // Toggle navigation
        var evName = ('ontouchstart' in document.documentElement) ? 'touchstart' : 'click';
        $('.menubtn', '#cc-m-container').bind(evName, function(e) {
            e.preventDefault();
            $('nav').toggle();
        });
        // Toggle navigation level groups
        $('.cc-nav-expand > a, .cc-nav-expand-open > a, .menubtn').bind(evName, function(e) {
            e.preventDefault();
            $(this)
                .next('ul').slideToggle(200)
                .parent('li').toggleClass('cc-nav-expand cc-nav-expand-open');
        });
        // inline styling making us to change the style from js, sorry.
        $('#emotion-header').css('height', 'auto');
    });

})(require('jquery'));



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobile.js
 ** module id = 3708
 ** module chunks = 100
 **/